// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 14-May-2019 10:00:00 AM
// File Created Date      : 14-May-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        ajaxFormSubmit: false,
        title: 'Document',
        selecting: true,
        multiselect: true,
        inlineEditor: {
            enabled: true,
            autoSave: true,
            emptyRow: true
        },
        card: {
            type: 'Grid'
        },
        actions: {
            listAction: "/api/Documents/GetDocuments/",
            deleteAction: "/api/Documents/",
            updateAction: "/api/Documents",
            createAction: "/api/Documents"
        },
        fields: {
            DocumentStoreId: {
                primaryKey: true
            },
            TransactionId: {
                parent: true
            },
            FileName: {
                type: "File",
                title: "File Name",
                download: true,
                uploadedName: 'UploadedName',
                required: true,
                sortable: true,
                editReadonly: true,
                create: true
            },
            DocumentTagId: {
                type: "ComboBox",
                autocomplete: true,
                required: true,
                title: "Document Type",
                sortable: true,
            },
            Date: {
                type: "Date",
                displayCurrentDate: true,
                readonly: true,
                title: "Uploaded Date"
            },
            Description: {
                type: "TextArea",
                counter: 500,
                title: "Notes"
            },
            VersionNo: {
                type: "Hidden"
            },
            DocumentStoreDetailId: {
                type: "Hidden"
            },
            UploadedName: {
                type: "Hidden"
            },
            Language: {
                title: "Language",
                required: true,
                type: "ComboBox",
                autocomplete: true
            },
            copyUrl: {
                prepend: true,
                type: "button",
                icon: "mdi-content-copy",
                size: "18",
                color: "#557fb5",
                tooltip: "copy url",
                method: "urlCopy"
            },
        },
    },

    //#. Used to access data from the state tree of the store
    getters: {
    },

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {

        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },
        urlCopy(state, payload) {
            const link = process.env.VUE_APP_API_Base_URL + `api/Documents/Download/${payload.payload.item.UploadedName}`;
            let dashboard = state.dashboard;
            var el = document.createElement('textarea');
            el.value = link;
            el.setAttribute('readonly', '');
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            dashboard.color = "success";
            dashboard.text = "Copied to clipboard";
            dashboard.snackbar = true;
        },
        iconInserted(state, context) {
            if (context.payload.field.value == 'copyUrl') {
                context.payload.field.copyUrl = true;
            } else {
                context.payload.field.copyUrl = false;
            }
        },
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },
        iconInserted: ({ commit, rootState }, payload) => {
            commit('iconInserted', { rootState, payload });
        },
        urlCopy: ({ commit, rootState }, payload) => {
            commit('urlCopy', { rootState, payload });
        }
    }
}